import React from "react"
import { useDispatch } from "react-redux"
import { deleteSAMLConfiguration } from "reduxSlices/SAMLConfigurationsSlice"
import { SAMLConfigurationShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"
import { CircularIconButton } from "shared/buttons"
import SAMLConfigurationsListItemMetadataSection from "./SAMLConfigurationsListItemMetadataSection"
import SAMLConfigurationsListItemNameSection from "./SAMLConfigurationsListItemNameSection"
import SAMLConfigurationsListItemServiceProviderMetadataSection from "./SAMLConfigurationsListItemServiceProviderMetadataSection"
import SAMLConfigurationsListItemSLOSection from "./SAMLConfigurationsListItemSLOSection"

const CONFIRM_DELETE_MESSAGE = "Are you sure you want to delete this organization's SAML configuration?"
  + "\n\n"
  + "Removing the SAML configuration will change the organization's authentication method from SSO to email/password."

const SAMLConfigurationsListItem = ({ configuration }) => {
  const dispatch = useDispatch()
  const { displayName, id, legacy } = configuration

  const deleteConfiguration = () => {
    if (window.confirm(CONFIRM_DELETE_MESSAGE)) {
      dispatch(deleteSAMLConfiguration({ id }))
    }
  }

  return (
    <ItemRow
      collapsable
      itemRowHeaderContent={(
        <>
          <span>{displayName}</span>
          {legacy && <span className="warning-badge">Legacy</span>}
        </>
      )}
      itemRowHeaderControls={(
        <CircularIconButton ariaLabel="Delete SAML configuration" icon="close" onClick={deleteConfiguration} />
      )}
      itemRowBody={(
        <div>
          <SAMLConfigurationsListItemNameSection configuration={configuration} />
          <SAMLConfigurationsListItemSLOSection configuration={configuration} />
          <SAMLConfigurationsListItemServiceProviderMetadataSection configuration={configuration} />
          <SAMLConfigurationsListItemMetadataSection configuration={configuration} />
        </div>
      )}
    />
  )
}

SAMLConfigurationsListItem.propTypes = {
  configuration: SAMLConfigurationShape.isRequired,
}

export default SAMLConfigurationsListItem
